import * as Y from 'yjs';
import { Editor } from '@tiptap/core';
import StarterKit from '@tiptap/starter-kit';
import Collaboration from '@tiptap/extension-collaboration';
import Link from '@tiptap/extension-link';
import { BulletListWithoutInputRules, OrderedListWithoutInputRules, createLiveYDoc } from '@narrativebench/editor-core';

export async function convertHtmlToYjs(html: string): Promise<Uint8Array> {
  const ydoc = createLiveYDoc();
  const yxmlFragment = ydoc.getXmlFragment('default');

  const tempDiv = document.createElement('div');
  tempDiv.style.position = 'absolute';
  tempDiv.style.left = '-9999px';
  tempDiv.style.visibility = 'hidden';
  document.body.appendChild(tempDiv);

  const editor = new Editor({
    element: tempDiv,
    extensions: [
      StarterKit.configure({
        bulletList: false,
        orderedList: false,
        link: false,
      }) as any,
      BulletListWithoutInputRules,
      OrderedListWithoutInputRules,
      Link.configure({
        openOnClick: true,
        HTMLAttributes: {
          target: '_blank',
          rel: 'noopener noreferrer nofollow',
        },
      }),
      Collaboration.configure({
        fragment: yxmlFragment,
      }),
    ],
    editable: false,
  });

  try {
    editor.commands.setContent(html);
    await new Promise((resolve) => setTimeout(resolve, 0));
    const state = Y.encodeStateAsUpdate(ydoc);
    return state;
  } finally {
    editor.destroy();
    document.body.removeChild(tempDiv);
    ydoc.destroy();
  }
}

